import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck, Headset, Truck, CreditCard } from "lucide-react";
import localizedLink from "../../utils/localizedLink";

const BENEFITS = [
    { key: "delivery", Icon: Truck, to: "/policies/delivery" },
    { key: "support", Icon: Headset, href: "tel:574180111" },
    { key: "warranty", Icon: ShieldCheck, to: "/policies/warranty" },
    { key: "instalment", Icon: CreditCard },
];

// Compact cards like eufy.com, tighter still where they stack on phones. A
// lighter gray than the product cards keeps them as supporting info.
// Bracket values where Bootstrap's !important spacing (p-4, gap-3...) would win.
const CARD_CLASS_NAME =
    "flex h-full items-center gap-[12px] rounded-xl bg-[#f5f6f7] px-[12px] py-[10px] sm:rounded-2xl sm:px-[16px] sm:py-[12px]";
const LINK_CLASS_NAME = `${CARD_CLASS_NAME} transition-colors hover:bg-[#eaeaec]`;

export default function Benefits() {
    const { t, i18n } = useTranslation();

    return (
        <Row className="mt-2">
            <div className="grid grid-cols-1 gap-[8px] sm:grid-cols-2 sm:gap-[12px] lg:grid-cols-4">
                {BENEFITS.map(({ key, Icon, to, href }) => {
                    const content = (
                        <>
                            <span
                                className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#eaeaec] text-[#080a0f] sm:h-10 sm:w-10"
                            >
                                <Icon className="h-4 w-4 sm:h-5 sm:w-5" strokeWidth={1.75} />
                            </span>
                            <span className="text-sm font-medium leading-snug md:text-base">
                                {t(`home.benefits.${key}`)}
                            </span>
                        </>
                    );

                    if (to) {
                        return (
                            <Link key={key} to={localizedLink(to, i18n.language)} className={LINK_CLASS_NAME}>
                                {content}
                            </Link>
                        );
                    }
                    if (href) {
                        return (
                            <a key={key} href={href} className={LINK_CLASS_NAME}>
                                {content}
                            </a>
                        );
                    }
                    return (
                        <div key={key} className={CARD_CLASS_NAME}>
                            {content}
                        </div>
                    );
                })}
            </div>
        </Row>
    );
}
